// extracted by mini-css-extract-plugin
module.exports = {"container":"_25ais","tmalllogo":"_2SN61"};